import { inject, Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { catchError, Observable, of } from 'rxjs';
import { Resposta } from '../../../core/models/base/base.models';
import { environment } from '../../../../environments/environment';

@Injectable({ providedIn: 'root' })
export class AuthToggleService {
    private static readonly PATH = '/internal/auth/status';

    private readonly http = inject(HttpClient);

    public consultar(): Observable<Resposta<boolean>> {
        const url = `${environment.apiUrl}${AuthToggleService.PATH}`;
        return this.http.get<Resposta<boolean>>(url).pipe(catchError(() => of({ dados: null, erros: null })));
    }
}
